import * as React from 'react';

const Send = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1703 0.224751C22.8575 -0.0313231 22.4288 -0.0705562 22.0779 0.124751L1.29675 11.6458C0.785814 11.9242 0.475769 12.4855 0.501485 13.0855C0.527201 13.6856 0.88403 14.2159 1.41675 14.4458L4.54059 15.8258C4.54058 15.9093 4.55455 15.9922 4.58187 16.0708L6.98187 22.8168C7.23746 23.5319 7.89477 24.0044 8.62731 23.9998C9.05985 23.9958 9.47608 23.8272 9.79755 23.5258C9.83499 23.4908 12.4759 20.4478 13.0615 19.7718C13.1301 19.6927 13.2393 19.6678 13.3332 19.7098L16.3639 21.0488C16.7647 21.2253 17.2186 21.2155 17.6119 21.0218C18.0025 20.8296 18.2946 20.4713 18.4135 20.0388L23.5054 1.29975C23.6136 0.903796 23.4812 0.479016 23.1703 0.224751ZM6.10731 16.0458L15.4116 7.98275C15.4551 7.93686 15.5153 7.91247 15.577 7.91572C15.6388 7.91897 15.6964 7.94954 15.7351 7.99975C15.784 8.03852 15.8141 8.09756 15.8176 8.16138C15.8211 8.22521 15.7976 8.28744 15.7534 8.33175L8.80491 17.1868C8.72538 17.2876 8.67332 17.4088 8.65419 17.5378L8.04651 21.4878L6.10731 16.0458Z"
    />
  </svg>
);

export default Send;
